'use strict';

export default {
    updateFindUsList: (state, payload) => state.findUsList = payload,
    updateBlogPosts: (state, payload) => state.blogPosts = payload,
    updateJobsList: (state, payload) => state.jobsList = payload,
    updateForm: (state, payload) => state.form = payload
}